export default "__VITE_ASSET__AKEvk2Uj__"